import React from "react";
import { motion } from "framer-motion";
import SectionHeading from "../../components/SectionHeading";
import { storyContent } from "./aboutContent";

/* Reuses the page's existing photograph (public/assets/about-bg.webp) — the
   approved document ships no imagery of its own, so nothing new was sourced. */
const AboutStory = () => {
  const storyImage = `${process.env.PUBLIC_URL}/assets/about-bg.webp`;

  return (
    <section
      className="bg-gray-50 py-14 lg:py-20"
      aria-labelledby="about-story-heading"
    >
      <div className="sectionlayout">
        <SectionHeading
          id="about-story-heading"
          title={storyContent.title}
          subtitle={storyContent.subtitle}
        />
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            className="space-y-4"
          >
            {storyContent.paragraphs.map((paragraph) => (
              <p
                key={paragraph}
                className="text-sm md:text-base leading-relaxed text-gray-600"
              >
                {paragraph}
              </p>
            ))}
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.5, delay: 0.1, ease: "easeOut" }}
            className="overflow-hidden rounded-2xl border border-gray-100 shadow-xl"
          >
            <img
              src={storyImage}
              alt="MBA Solutions consultancy team at work"
              className="h-[240px] w-full object-cover md:h-[320px] lg:h-[380px]"
              loading="lazy"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutStory;
